





import { Vue } from 'vue-property-decorator';

export default class Loading extends Vue {}
